import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetSocialPostDetailV1Response } from './get-social-post-detail-v1-response';
import { getSocialPostDetailV1ResponseSchema } from './get-social-post-detail-v1-response';

export async function getSocialPostDetailV1Api(
  postId: number,
): Promise<IValidatedResponse<IGetSocialPostDetailV1Response>> {
  return getRequest<IGetSocialPostDetailV1Response>({
    path: `/sys/social/v1/posts/${postId}`,
    schema: getSocialPostDetailV1ResponseSchema,
  });
}
